export default "__VITE_ASSET__d20ccbd4__"